export default {
	TIPO_ESTORNO_ITEM_PEDIDO: {
		ESTORNO_PARCIAL: { text: 'Estorno Parcial', value: 'ESTORNO_PARCIAL' },
		ESTORNO_COMPLETO: { text: 'Estorno Completo', value: 'ESTORNO_COMPLETO' },
	},
	TIPO_ESTORNO_ITEM_ADESAO: {
		ESTORNO_PARCIAL: { text: 'Estorno Parcial', value: 'ESTORNO_PARCIAL' },
		ESTORNO_COMPLETO: { text: 'Estorno Completo', value: 'ESTORNO_COMPLETO' },
	},
	AUTORIZACAO_PEDIDO: {
		AUTORIZADO: { text: 'Autorizado', value: 'AUTORIZADO' },
		NAO_AUTORIZADO: { text: 'Não Autorizado', value: 'NAO_AUTORIZADO' },
		NAO_DEFINIDO: { text: 'Não Definido', value: 'NAO_DEFINIDO' },
	},
}
